(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SC-affirm-calculate"] && !Shopify.designMode) return;
  try {
    
  function formatCurrency(amount) {
      return parseFloat(amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function calculatePayments(purchaseAmount) {
      const apr = 0.15;
      const monthlyInterestRate = apr / 12;

      const interestFreePayments = {
          numberOfPayments: 4,
          paymentAmount: purchaseAmount / 4,
          totalCost: purchaseAmount
      };

      const calculateMonthlyPayment = (months) => {
          const payment = (purchaseAmount * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, months)) /
              (Math.pow(1 + monthlyInterestRate, months) - 1);
          const totalCost = payment * months;
          return {
              paymentAmount: payment,
              totalCost: totalCost,
              totalInterest: totalCost - purchaseAmount
          };
      };

      const sixMonthlyPayments = calculateMonthlyPayment(6);
      const twelveMonthlyPayments = calculateMonthlyPayment(12);

      return {
          interestFreePayments,
          sixMonthlyPayments,
          twelveMonthlyPayments
      };
  }

  document.getElementById('purchaseSlider').addEventListener('input', function (e) {
      const values = [100, 200, 300, 400, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000];
      const selectedValue = values[e.target.value];
      document.querySelector('.purchase-amount').textContent = formatCurrency(selectedValue);

      const paymentOptions = calculatePayments(selectedValue);

      const updatePaymentDetails = (paymentOption, amountId, totalCostId, interestId = null) => {
          document.querySelector(`#${amountId}`).textContent = formatCurrency(paymentOption.paymentAmount.toFixed(2));
          document.querySelector(`#${totalCostId}`).textContent = `Total cost: ${formatCurrency(paymentOption.totalCost.toFixed(2))}`;
          if (interestId) {
              document.querySelector(`#${interestId}`).textContent = `Total interest at 15% APR: ${formatCurrency(paymentOption.totalInterest.toFixed(2))}`;
          }
      };

      updatePaymentDetails(paymentOptions.interestFreePayments, 'amount-4', 'total-cost-4');
      updatePaymentDetails(paymentOptions.sixMonthlyPayments, 'amount-6', 'total-cost-6', 'plans-6-interest');
      updatePaymentDetails(paymentOptions.twelveMonthlyPayments, 'amount-12', 'total-cost-12', 'plans-12-interest');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SC-photo-wall"] && !Shopify.designMode) return;
  try {
    
      let magicGrid = new MagicGrid({
        container: '.photo_wall--container',
        animate: false,
        gutter: 15,
        static: true,
        useMin: true,
        useTransform: true,
        });
      magicGrid.listen();

  $(document).ready(function () {
      let magicGrid = new MagicGrid({
        container: '.photo_wall--container',
        animate: false,
        gutter: 15,
        static: true,
        useMin: true,
        useTransform: true,
        });
      magicGrid.listen();

    // document.addEventListener("visibilitychange", function() {
    //    if (document.hidden){
    //        console.log("Browser tab is hidden")
    //    } else {
    //        console.log("Browser tab is visible")
    //        location.reload();
    //    }
    // });
  });

  } catch(e) { console.error(e); }
})();
})();
